import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BackendService } from '@tg4/http-infrastructure/dist/src';
import { Observable } from 'rxjs';
import { AuthService } from '../shared/services/auth.service';
import { CycleService } from '../shared/services/cycle.service';
import { ContinuousFeedbackEventEnum } from './interfaces/feedback-record.interface';

@Injectable({
    providedIn: 'root',
})
export class FeedbackService {
    constructor(private _httpService: BackendService,
                private authService: AuthService,
                private http: HttpClient,
                private _cycleService: CycleService,
    ) {
    }

    // GET

    public getFeedbackEnabledAttributes(SearchKey: string): Observable<any> {
        return this._httpService.get('getFeedbackEnabledAttributes', [], [
            { 'name': 'SearchKey', 'value': SearchKey as any }
        ]);
    }

    public getFeedbackEnabledAttributeById(Id: number): Observable<any> {
        return this._httpService.get('getFeedbackEnabledAttributeById', [], [
            { 'name': 'id', 'value': Id as any }
        ]);
    }

    public getFeedbackPrinciples(): Observable<any> {
        return this._httpService.get('getFeedbackPrinciples', [], []);
    }

    public getAttributes(parameters): Observable<any> {
        return this._httpService.get('searchAttributesAndUsers', [], parameters);
    }

    public getFeedbackDashboard(): Observable<any> {
        return this._httpService.get('getFeedbackDashboard', [], []);
    }

    public getFeedbacks(SearchKey: string): Observable<any> {
        return this._httpService.get('getFeedbacks', [], [
            { 'name': 'SearchKey', 'value': SearchKey as any }
        ]);
    }

    public getFeedbackRecordUser(userId: string): Observable<any> {
        return this._httpService.get('getFeedbackRecordUser', [], [
            { 'name': 'userId', 'value': userId }
        ]);
    }

    public getFeedbackUsers(page: number = 1, pageSize: number = 10, search = ''): Observable<any> {
        let cycleId = this._cycleService.getCycle();
        return this._httpService.get('getFeedbackUsers', [], [
            { 'name': 'page', 'value': page as any },
            { 'name': 'pageSize', 'value': pageSize as any },
            { 'name': 'search', 'value': search as any },
            { 'name': 'cycleId', 'value': cycleId as any }
        ]);
    }

    public getAttributesToFeedback(attributeType: number): Observable<any> {
        return this._httpService.get('searchAttributesToFeedback', [], [
            { name: 'type', value: attributeType as any },
            { name: 'limit', value: false },
            { name: 'onlyActiveAttributes', value: true },
        ]);
    }


    // POST

    public addFeedbackEnabledAttribute(feedbackGroup: any): Observable<any> {
        return this._httpService.post('addFeedbackEnabledAttribute', {
            'feedbackAttributesEnabled': feedbackGroup.FeedbackAttributesEnabled,
            'globalizationConfig': feedbackGroup.GlobalizationConfig,
        });
    }

    public updateFeedbackEnabledAttribute(feedbackGroup: any): Observable<any> {
        return this._httpService.put('updateFeedbackEnabledAttribute', {
            'id': feedbackGroup.Id,
            'feedbackAttributesEnabled': feedbackGroup.FeedbackAttributesEnabled,
            'globalizationConfig': feedbackGroup.GlobalizationConfig,
        });
    }

    public createFeedback(SubjectUserIds: string[], Event: ContinuousFeedbackEventEnum,
                          Comment: string, Principles: any[]): Observable<any> {
        return this._httpService.post('createFeedback', {
            'subjectUserIds': SubjectUserIds,
            'event': Event,
            'comment': Comment,
            'principles': Principles
        });
    }

    public createFeedbackReaction(Id: number, Reaction: number): Observable<any> {
        return this._httpService.post('createFeedbackReaction', {
            'id': Id,
            'reaction': Reaction
        });
    }

    public markFeedbackAsRead(feedbackId: number): Observable<any> {
        return this._httpService.post('markFeedbackAsRead',
                { 'feedbackId': feedbackId as any }
        );
    }


    // DELETE
    public deleteFeedbackGroupEnabledAttribute(Id: number): Observable<any> {
        return this._httpService.delete('deleteFeedbackGroupEnabledAttribute', [
            { name: 'Id', value: Id as any }
        ]);
    }

    // UPDATE
}
